export function NotFound(): JSX.Element {
  return (
    <div className="page flex min-h-[50vh] items-center justify-center">
      <div className="text-center space-y-2">
        <p className="font-sans text-5xl text-ink">404</p>
        <p className="text-sm text-muted-foreground">Page not found.</p>
      </div>
    </div>
  );
}
